import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import styled from '@emotion/styled';
import Row from '@amzn/meridian/row';
import Text from '@amzn/meridian/text';
import { CurrencyPosition } from 'src/utils/priceUtils';
const SupText = styled(Text) `
  padding-top: ${({ small }) => (small ? '5px' : '7px')};
`;
// In V1, the small version is 22px for the base text, and 13px for the sup text.
// TODO: The values below are the closest to line up. To be signed off by David during fit and finish
export const LargePrice = ({ size, currencySymbol, basePart, fractionalPart, currencySymbolPosition, }) => {
    const small = size === 'small';
    return (_jsxs(Row, { spacing: "none", alignmentVertical: "top", "data-testid": "large-price", children: [currencySymbolPosition === CurrencyPosition.LEFT && (_jsx(SupText, { small: small, type: small ? 'b100' : 'b200', "data-testid": "currency-symbol", children: currencySymbol })), _jsx(Text, { type: small ? 'h400' : 'd50', "data-testid": "base-amount", children: _jsx("b", { children: basePart }) }), fractionalPart && (_jsxs(SupText, { small: small, type: small ? 'b100' : 'b200', "data-testid": "fractional-amount", children: [fractionalPart, " ", currencySymbolPosition === CurrencyPosition.RIGHT && currencySymbol] }))] }));
};
